import baseURL from './url';

const CSRF_HEADER_NAME = 'X-CSRF-Token';
const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

let csrfTokenPromise = null;

const canPatchFetch = typeof window !== 'undefined' && typeof window.fetch === 'function';
const originalFetch = canPatchFetch ? window.fetch.bind(window) : null;
const isRequest = (resource) => typeof Request !== 'undefined' && resource instanceof Request;

const getRequestMethod = (resource, options = {}) => {
    const requestMethod = isRequest(resource) ? resource.method : 'GET';
    return String(options.method || requestMethod || 'GET').toUpperCase();
};

const getRequestUrl = (resource) => {
    if (isRequest(resource)) {
        return resource.url;
    }

    return String(resource);
};

const isSameOriginRequest = (resource) => {
    try {
        const requestUrl = new URL(getRequestUrl(resource), window.location.origin);
        const appBaseUrl = new URL(baseURL, window.location.origin);

        return requestUrl.origin === window.location.origin && requestUrl.origin === appBaseUrl.origin;
    } catch (error) {
        return false;
    }
};

const isCsrfTokenRequest = (resource) => {
    try {
        const requestUrl = new URL(getRequestUrl(resource), window.location.origin);
        return requestUrl.pathname.endsWith('/csrfToken.php');
    } catch (error) {
        return false;
    }
};

const getCsrfToken = async () => {
    if (!csrfTokenPromise) {
        csrfTokenPromise = originalFetch(`${baseURL}/csrfToken.php`, {
            cache: 'no-store',
            credentials: 'same-origin',
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('No se pudo preparar la sesion segura.');
                }

                return response.json();
            })
            .then((data) => data.csrfToken || '');
    }

    return csrfTokenPromise;
};

if (canPatchFetch) {
    window.fetch = async (resource, options = {}) => {
        const method = getRequestMethod(resource, options);

        if (!UNSAFE_METHODS.has(method) || !isSameOriginRequest(resource) || isCsrfTokenRequest(resource)) {
            return originalFetch(resource, options);
        }

        const token = await getCsrfToken();
        const headers = new Headers(options.headers || (isRequest(resource) ? resource.headers : undefined));

        if (token && !headers.has(CSRF_HEADER_NAME)) {
            headers.set(CSRF_HEADER_NAME, token);
        }

        return originalFetch(resource, {
            ...options,
            headers,
            credentials: options.credentials || 'same-origin',
        });
    };
}
